import script from "./SaleDocumentTypes.vue?vue&type=script&setup=true&lang=js"
export * from "./SaleDocumentTypes.vue?vue&type=script&setup=true&lang=js"

import "./SaleDocumentTypes.vue?vue&type=style&index=0&id=32d6ff9a&lang=css"

const __exports__ = script;

export default __exports__